import API from "../../../../../global/api";


export const requestDashboardData = () => {
    return {
        type: "REQUEST_DASHBOARD_DATA",
    };
};
export const successDashboardData = (data) => {
    return {
        type: "SUCCESS_DASHBOARD_DATA",
        payload: data,
    };
};
export const errorDashboardData = () => {
    return {
        type: "ERROR_DASHBOARD_DATA",
    };
};
export const DashboardDataApi = (data) => {
    return (dispatch) => {
        dispatch(requestDashboardData());
        API.post(`/reports/accounts-dashboard-data`, data).then((res) => {
            let getData = res.data;
            dispatch(successDashboardData(getData));
        }).catch((error) => {
            dispatch(errorDashboardData());
        })
    };
};

const STALE_THRESHOLD_MS = 5 * 60 * 1000;

export const DashboardDataApiIfStale = (data) => {
    return (dispatch, getState) => {
        const { lastFetched, isFetchingDashboardData } = getState().AccountsDashboardReducer;
        if (isFetchingDashboardData) return;
        const isStale = !lastFetched || Date.now() - lastFetched > STALE_THRESHOLD_MS;
        if (isStale) {
            dispatch(DashboardDataApi(data));
        }
    };
};